import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Smartphone, Plus, Trash2, Loader2 } from 'lucide-react';

const walletBadge = (s) => ({
  active: 'bg-emerald-50 border-emerald-200 text-emerald-700',
  pending: 'bg-amber-50 border-amber-200 text-amber-700',
  inactive: 'bg-zinc-100 border-zinc-200 text-zinc-500',
}[s] || 'bg-zinc-100 border-zinc-200 text-zinc-500');

export function WalletDomains({ domains, input, setInput, onRegister, loading, onDelete, delBusy }) {
  const visible = domains.filter((d) => d.enabled);
  return (
    <Card className="card-flat p-6" data-testid="wallet-domains">
      <div className="flex items-center gap-2 text-zinc-700 font-semibold mb-1">
        <Smartphone className="h-4 w-4" /> Apple Pay / Google Pay — domaines
      </div>
      <p className="text-xs text-zinc-500 mb-4">
        Enregistrez chaque domaine de paiement (domaine principal + domaines custom de vos boutiques) pour faire apparaître
        Apple Pay sur Safari. Google Pay fonctionne sans enregistrement. Stripe gère la validation automatiquement —
        aucun fichier à héberger.
      </p>
      <div className="flex gap-2 mb-4">
        <Input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="checkout-commande.live"
          className="h-10 rounded-md font-mono text-sm"
          data-testid="wallet-domain-input"
        />
        <Button onClick={onRegister} disabled={loading || !input.trim()} className="btn-primary rounded-md whitespace-nowrap" data-testid="wallet-domain-register">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Plus className="h-4 w-4 mr-1" /> Enregistrer</>}
        </Button>
      </div>
      {visible.length === 0 ? (
        <div className="text-sm text-zinc-400">Aucun domaine actif sur ce compte</div>
      ) : (
        <div className="space-y-2">
          {visible.map((d) => (
            <div key={d.id} className="flex items-center justify-between gap-3 border border-zinc-100 rounded-md px-3 py-2" data-testid="wallet-domain-row">
              <span className="font-mono text-sm text-zinc-700 truncate">{d.domain}</span>
              <div className="flex items-center gap-1.5 shrink-0">
                <span className={`px-2 py-0.5 rounded-md border text-xs ${walletBadge(d.apple_pay)}`}>Apple&nbsp;Pay&nbsp;: {d.apple_pay}</span>
                <span className={`px-2 py-0.5 rounded-md border text-xs ${walletBadge(d.google_pay)}`}>Google&nbsp;Pay&nbsp;: {d.google_pay}</span>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 rounded-md text-zinc-400 hover:text-red-600 hover:bg-red-50"
                  disabled={delBusy === d.id}
                  onClick={() => onDelete(d.id)}
                  title="Supprimer ce domaine"
                  data-testid="wallet-domain-delete"
                >
                  {delBusy === d.id ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />}
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
